/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { DdtAspectListResponse } from '../models/ddt-aspect-list-response';
import { ddtControllerCreate } from '../fn/ddt/ddt-controller-create';
import { DdtControllerCreate$Params } from '../fn/ddt/ddt-controller-create';
import { ddtControllerCreateSubject } from '../fn/ddt/ddt-controller-create-subject';
import { DdtControllerCreateSubject$Params } from '../fn/ddt/ddt-controller-create-subject';
import { ddtControllerDeleteSubject } from '../fn/ddt/ddt-controller-delete-subject';
import { DdtControllerDeleteSubject$Params } from '../fn/ddt/ddt-controller-delete-subject';
import { ddtControllerDownloadOne } from '../fn/ddt/ddt-controller-download-one';
import { DdtControllerDownloadOne$Params } from '../fn/ddt/ddt-controller-download-one';
import { ddtControllerFindHistory } from '../fn/ddt/ddt-controller-find-history';
import { DdtControllerFindHistory$Params } from '../fn/ddt/ddt-controller-find-history';
import { ddtControllerGenerateNumber } from '../fn/ddt/ddt-controller-generate-number';
import { DdtControllerGenerateNumber$Params } from '../fn/ddt/ddt-controller-generate-number';
import { ddtControllerGetAll } from '../fn/ddt/ddt-controller-get-all';
import { DdtControllerGetAll$Params } from '../fn/ddt/ddt-controller-get-all';
import { ddtControllerGetAspects } from '../fn/ddt/ddt-controller-get-aspects';
import { DdtControllerGetAspects$Params } from '../fn/ddt/ddt-controller-get-aspects';
import { ddtControllerGetCouriers } from '../fn/ddt/ddt-controller-get-couriers';
import { DdtControllerGetCouriers$Params } from '../fn/ddt/ddt-controller-get-couriers';
import { ddtControllerGetOne } from '../fn/ddt/ddt-controller-get-one';
import { DdtControllerGetOne$Params } from '../fn/ddt/ddt-controller-get-one';
import { ddtControllerGetPorts } from '../fn/ddt/ddt-controller-get-ports';
import { DdtControllerGetPorts$Params } from '../fn/ddt/ddt-controller-get-ports';
import { ddtControllerGetStatuses } from '../fn/ddt/ddt-controller-get-statuses';
import { DdtControllerGetStatuses$Params } from '../fn/ddt/ddt-controller-get-statuses';
import { ddtControllerGetSubjects } from '../fn/ddt/ddt-controller-get-subjects';
import { DdtControllerGetSubjects$Params } from '../fn/ddt/ddt-controller-get-subjects';
import { ddtControllerPreviewEmailBody } from '../fn/ddt/ddt-controller-preview-email-body';
import { DdtControllerPreviewEmailBody$Params } from '../fn/ddt/ddt-controller-preview-email-body';
import { ddtControllerSendEmail } from '../fn/ddt/ddt-controller-send-email';
import { DdtControllerSendEmail$Params } from '../fn/ddt/ddt-controller-send-email';
import { ddtControllerUpdate } from '../fn/ddt/ddt-controller-update';
import { DdtControllerUpdate$Params } from '../fn/ddt/ddt-controller-update';
import { ddtControllerUpdateSubject } from '../fn/ddt/ddt-controller-update-subject';
import { DdtControllerUpdateSubject$Params } from '../fn/ddt/ddt-controller-update-subject';
import { DdtCourierListResponse } from '../models/ddt-courier-list-response';
import { DdtHistoryResponse } from '../models/ddt-history-response';
import { DdtItem } from '../models/ddt-item';
import { DdtListResponse } from '../models/ddt-list-response';
import { DdtNumeration } from '../models/ddt-numeration';
import { DdtPortListResponse } from '../models/ddt-port-list-response';
import { DdtStatusListResponse } from '../models/ddt-status-list-response';
import { DdtSubject } from '../models/ddt-subject';
import { DdtSubjectListResponse } from '../models/ddt-subject-list-response';
import { EmptyResponse } from '../models/empty-response';
import { StringItem } from '../models/string-item';

@Injectable({ providedIn: 'root' })
export class DdtService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ddtControllerPreviewEmailBody()` */
  static readonly DdtControllerPreviewEmailBodyPath = '/ddt/{id}/preview-body';

  /**
   * Preview del body di una mail DDT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerPreviewEmailBody()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerPreviewEmailBody$Response(params: DdtControllerPreviewEmailBody$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>> {
    return ddtControllerPreviewEmailBody(this.http, this.rootUrl, params, context);
  }

  /**
   * Preview del body di una mail DDT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerPreviewEmailBody$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerPreviewEmailBody(params: DdtControllerPreviewEmailBody$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StringItem;
}> {
    return this.ddtControllerPreviewEmailBody$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>): BaseResponse & {
'data'?: StringItem;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerSendEmail()` */
  static readonly DdtControllerSendEmailPath = '/ddt/{id}/send-email';

  /**
   * Invia una mail per un DDT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerSendEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ddtControllerSendEmail$Response(params: DdtControllerSendEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return ddtControllerSendEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia una mail per un DDT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerSendEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ddtControllerSendEmail(params: DdtControllerSendEmail$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.ddtControllerSendEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerGetAll()` */
  static readonly DdtControllerGetAllPath = '/ddt';

  /**
   * Elenco dei DDT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetAll$Response(params: DdtControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtListResponse;
}>> {
    return ddtControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Elenco dei DDT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetAll(params: DdtControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtListResponse;
}> {
    return this.ddtControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtListResponse;
}>): BaseResponse & {
'data'?: DdtListResponse;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerCreate()` */
  static readonly DdtControllerCreatePath = '/ddt';

  /**
   * Crea un DDT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ddtControllerCreate$Response(params: DdtControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtItem;
}>> {
    return ddtControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un DDT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ddtControllerCreate(params: DdtControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtItem;
}> {
    return this.ddtControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtItem;
}>): BaseResponse & {
'data'?: DdtItem;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerGenerateNumber()` */
  static readonly DdtControllerGenerateNumberPath = '/ddt/generate-number';

  /**
   * Genera la numerazione del DDT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerGenerateNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGenerateNumber$Response(params?: DdtControllerGenerateNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtNumeration;
}>> {
    return ddtControllerGenerateNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * Genera la numerazione del DDT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerGenerateNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGenerateNumber(params?: DdtControllerGenerateNumber$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtNumeration;
}> {
    return this.ddtControllerGenerateNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtNumeration;
}>): BaseResponse & {
'data'?: DdtNumeration;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerGetSubjects()` */
  static readonly DdtControllerGetSubjectsPath = '/ddt/subject';

  /**
   * Restituisce l'elenco delle causali.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerGetSubjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetSubjects$Response(params?: DdtControllerGetSubjects$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtSubjectListResponse;
}>> {
    return ddtControllerGetSubjects(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle causali.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerGetSubjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetSubjects(params?: DdtControllerGetSubjects$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtSubjectListResponse;
}> {
    return this.ddtControllerGetSubjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtSubjectListResponse;
}>): BaseResponse & {
'data'?: DdtSubjectListResponse;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerCreateSubject()` */
  static readonly DdtControllerCreateSubjectPath = '/ddt/subject';

  /**
   * Crea una causale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerCreateSubject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ddtControllerCreateSubject$Response(params: DdtControllerCreateSubject$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtSubject;
}>> {
    return ddtControllerCreateSubject(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una causale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerCreateSubject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ddtControllerCreateSubject(params: DdtControllerCreateSubject$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtSubject;
}> {
    return this.ddtControllerCreateSubject$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtSubject;
}>): BaseResponse & {
'data'?: DdtSubject;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerFindHistory()` */
  static readonly DdtControllerFindHistoryPath = '/ddt/{id}/history';

  /**
   * Storico delle modifiche di un DDT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerFindHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerFindHistory$Response(params: DdtControllerFindHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtHistoryResponse;
}>> {
    return ddtControllerFindHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Storico delle modifiche di un DDT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerFindHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerFindHistory(params: DdtControllerFindHistory$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtHistoryResponse;
}> {
    return this.ddtControllerFindHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtHistoryResponse;
}>): BaseResponse & {
'data'?: DdtHistoryResponse;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerGetOne()` */
  static readonly DdtControllerGetOnePath = '/ddt/{id}';

  /**
   * Restituisce un DDT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetOne$Response(params: DdtControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtItem;
}>> {
    return ddtControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un DDT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetOne(params: DdtControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtItem;
}> {
    return this.ddtControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtItem;
}>): BaseResponse & {
'data'?: DdtItem;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerUpdate()` */
  static readonly DdtControllerUpdatePath = '/ddt/{id}';

  /**
   * Aggiorna un DDT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ddtControllerUpdate$Response(params: DdtControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtItem;
}>> {
    return ddtControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiorna un DDT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ddtControllerUpdate(params: DdtControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtItem;
}> {
    return this.ddtControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtItem;
}>): BaseResponse & {
'data'?: DdtItem;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerUpdateSubject()` */
  static readonly DdtControllerUpdateSubjectPath = '/ddt/subject/{id}';

  /**
   * Modifica una causale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerUpdateSubject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ddtControllerUpdateSubject$Response(params: DdtControllerUpdateSubject$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtSubject;
}>> {
    return ddtControllerUpdateSubject(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica una causale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerUpdateSubject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ddtControllerUpdateSubject(params: DdtControllerUpdateSubject$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtSubject;
}> {
    return this.ddtControllerUpdateSubject$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtSubject;
}>): BaseResponse & {
'data'?: DdtSubject;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerDeleteSubject()` */
  static readonly DdtControllerDeleteSubjectPath = '/ddt/subject/{id}';

  /**
   * Elimina una causale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerDeleteSubject()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerDeleteSubject$Response(params: DdtControllerDeleteSubject$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtSubject;
}>> {
    return ddtControllerDeleteSubject(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina una causale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerDeleteSubject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerDeleteSubject(params: DdtControllerDeleteSubject$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtSubject;
}> {
    return this.ddtControllerDeleteSubject$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtSubject;
}>): BaseResponse & {
'data'?: DdtSubject;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerGetPorts()` */
  static readonly DdtControllerGetPortsPath = '/ddt/port';

  /**
   * Restituisce l'elenco dei porti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerGetPorts()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetPorts$Response(params?: DdtControllerGetPorts$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtPortListResponse;
}>> {
    return ddtControllerGetPorts(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei porti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerGetPorts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetPorts(params?: DdtControllerGetPorts$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtPortListResponse;
}> {
    return this.ddtControllerGetPorts$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtPortListResponse;
}>): BaseResponse & {
'data'?: DdtPortListResponse;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerGetAspects()` */
  static readonly DdtControllerGetAspectsPath = '/ddt/aspect';

  /**
   * Restituisce l'elenco degli aspetti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerGetAspects()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetAspects$Response(params?: DdtControllerGetAspects$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtAspectListResponse;
}>> {
    return ddtControllerGetAspects(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli aspetti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerGetAspects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetAspects(params?: DdtControllerGetAspects$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtAspectListResponse;
}> {
    return this.ddtControllerGetAspects$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtAspectListResponse;
}>): BaseResponse & {
'data'?: DdtAspectListResponse;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerGetStatuses()` */
  static readonly DdtControllerGetStatusesPath = '/ddt/status';

  /**
   * Restituisce l'elenco degli status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerGetStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetStatuses$Response(params: DdtControllerGetStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtStatusListResponse;
}>> {
    return ddtControllerGetStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerGetStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetStatuses(params: DdtControllerGetStatuses$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtStatusListResponse;
}> {
    return this.ddtControllerGetStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtStatusListResponse;
}>): BaseResponse & {
'data'?: DdtStatusListResponse;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerGetCouriers()` */
  static readonly DdtControllerGetCouriersPath = '/ddt/courier';

  /**
   * Restituisce l'elenco dei corrieri.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerGetCouriers()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetCouriers$Response(params?: DdtControllerGetCouriers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtCourierListResponse;
}>> {
    return ddtControllerGetCouriers(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei corrieri.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerGetCouriers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerGetCouriers(params?: DdtControllerGetCouriers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DdtCourierListResponse;
}> {
    return this.ddtControllerGetCouriers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DdtCourierListResponse;
}>): BaseResponse & {
'data'?: DdtCourierListResponse;
} => r.body)
    );
  }

  /** Path part for operation `ddtControllerDownloadOne()` */
  static readonly DdtControllerDownloadOnePath = '/ddt/{id}/download';

  /**
   * Scarica il DDT in formato pdf.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ddtControllerDownloadOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerDownloadOne$Response(params: DdtControllerDownloadOne$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return ddtControllerDownloadOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Scarica il DDT in formato pdf.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ddtControllerDownloadOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ddtControllerDownloadOne(params: DdtControllerDownloadOne$Params, context?: HttpContext): Observable<Blob> {
    return this.ddtControllerDownloadOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
